import { ReactElement } from 'react';
import { useBusiness } from '../contexts/BusinessContext';
import { CircularProgress, Box, Typography, Paper, Alert } from '@mui/material';

interface ProtectedBusinessRouteProps {
  children: ReactElement;
}

function ProtectedBusinessRoute({ children }: ProtectedBusinessRouteProps) {
  const { business, isLoading: businessLoading, error } = useBusiness();

  // Show loading state if business data is loading
  if (businessLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  // Show error message if there's no business or an error occurred
  if (!business || error) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', p: 3 }}>
        <Paper elevation={3} sx={{ p: 4, maxWidth: 600 }}>
          <Typography variant="h5" component="h1" gutterBottom color="error">
            Business Access Error
          </Typography>
          <Alert severity="error" sx={{ mb: 2 }}>
            {error || "You don't have access to a business account."}
          </Alert>
          <Typography variant="body1">
            Please contact your administrator if you believe this is an error.
          </Typography>
        </Paper>
      </Box>
    );
  }

  return children;
}

export default ProtectedBusinessRoute;